module.exports = __webpack_public_path__ + "img/logo-motork.26b686fe.svg";